import { useSharePrices } from 'hooks/vault/useSharePrices'
import LineChart from './LineChart'
import EmptyState from '@components/shared/EmptyState'

const SharePriceChart = () => {
  const data = useSharePrices()
  return (
    <div className="h-full w-full lg:px-0">
      <div className="hidden border-b border-t border-th-input-border py-2 text-base font-semibold text-th-fgd-1 lg:mb-4 lg:block lg:border-none lg:px-0 lg:py-0 lg:text-2xl">
        Share Price Chart
      </div>
      <div className="pb-4 pt-2 text-th-fgd-1 lg:px-0 lg:pt-0">
        SLV Token price changes based on the total value of assets in the vault
        and fees accrued.
      </div>

      <div className="h-full">
        {!data || !data.length ? (
          <EmptyState text={'No Data'} />
        ) : (
          <LineChart data={data} lineKey="price" xAxisKey="date" />
        )}
      </div>
    </div>
  )
}

export default SharePriceChart
